import { Switch, Route, useLocation } from 'react-router-dom';
import LoginBixby from './containers/Login/Bixby';
import EmailLink from './containers/EmailLink';
import Login from './containers/Login';
import LoginComplete from './containers/Login/Complete';
import AccountComplete from './containers/Account/Complete';
import PasswordChange from './containers/Password/Change';
import PasswordReset from './containers/Password/Reset';
import PasswordExpire from './containers/Password/Expire';
import PasswordSend from './containers/Password/Send';
import Account from './containers/Account';
import Home from './containers/Home';
import ProductMy from './containers/Product/My';
import Purchase from './containers/Product/Purchase';
import PurchaseDetail from './containers/Product/Purchase/Detail';
import AutoPayment from './containers/Product/AutoPayment';
import PaymentComplete from './containers/Payment/Complete';
import CustomerCenter from './containers/CustomerCenter';
import Faq from './containers/Faq';
import Error from './containers/Error';
import User from './containers/User';
import { useUser } from './UserContext';
import { useModal } from './ModalContext';
import { useTranslation } from 'react-i18next';
import useCustomHistory from './hooks/useCustomHistory';
import { useEffect, useState } from 'react';
import PaymentFail from './containers/Payment/Fail';
import Payment from './containers/Payment';
import UserChange from './containers/User/Change';
// import Notice from './containers/Notice';
// import NoticeDetail from './containers/Notice/Detail';
import NoticeContainer from './containers/Notice/Container';
import LoginQR from './containers/Login/QR';
import { setShow500Page } from './services/axios';
import Error500 from './containers/Error/500';
import LoginRedirect from './containers/Login/Redirect';

function EmptyPage(): JSX.Element {
  return <div className="w-screen h-96"></div>;
}

export default function Router(): JSX.Element {
  const { isInit, isLogin } = useUser();
  const [isRedirect, setIsRedirect] = useState(false);
  const location = useLocation();
  const { showModal } = useModal();
  const { t } = useTranslation();
  const history = useCustomHistory();

  useEffect(() => {
    if (!isInit) return;
    setShow500Page(() => {
      history.replace('/500');
    });
    window.scrollTo(0, 0);
    if (!isLogin) {
      if (/^\/(product\/my|product\/auto-payment|payment|user)/gi.test(location.pathname)) {
        setIsRedirect(true);
        showModal({
          title: '',
          message: t('drawer/login_error'),
          success: () => {
            history.push('/login', {
              afterLoginEndpoint: encodeURIComponent(location.pathname + location.search),
            });
          },
          fail: () => {
            history.push('/');
          },
        });
      }
    } else {
      setIsRedirect(false);
    }
  }, [isInit, isLogin, location.pathname]);

  return (
    <main className="min-h-1/2">
      <Switch>
        {/* login */}
        <Route path="/login/redirect">
          <LoginRedirect />
        </Route>
        <Route exact path="/login/bixby">
          <LoginBixby />
        </Route>
        <Route exact path="/login/qr">
          <LoginQR />
        </Route>
        <Route path="/login/complete">
          <LoginComplete />
        </Route>
        <Route path="/login">
          <Login />
        </Route>

        {/* 이메일 인증요청 */}
        <Route path="/email-link">
          <EmailLink />
        </Route>

        {/* 회원가입 완료 */}
        <Route path="/account/complete">
          <AccountComplete />
        </Route>
        {/* 회원가입 스텝 */}
        <Route path="/account/:step">
          <Account />
        </Route>
        <Route path="/account">
          <Account />
        </Route>

        {/* password */}
        <Route path="/password/change">
          <PasswordChange />
        </Route>
        <Route path="/password/reset">
          <PasswordReset />
        </Route>
        <Route path="/password/expire">
          <PasswordExpire />
        </Route>
        <Route path="/password/send">
          <PasswordSend />
        </Route>

        {/* payment */}
        <Route path="/payment/fail">{isRedirect ? <EmptyPage /> : <PaymentFail />}</Route>
        <Route path="/payment/complete">{isRedirect ? <EmptyPage /> : <PaymentComplete />}</Route>
        <Route path="/payment">{isRedirect ? <EmptyPage /> : <Payment />}</Route>

        {/* 계정관리 */}
        <Route path="/user/change">{isRedirect ? <EmptyPage /> : <UserChange />}</Route>
        <Route path="/user">{isRedirect ? <EmptyPage /> : <User />}</Route>

        {/* 나의 이용권 */}
        <Route path="/product/my">{isRedirect ? <EmptyPage /> : <ProductMy />}</Route>

        {/* 자동 결제 관리 */}
        <Route path="/product/auto-payment">{isRedirect ? <EmptyPage /> : <AutoPayment />}</Route>
        {/* 이용권 상세 */}
        <Route path="/product/purchase/:index" component={PurchaseDetail} />
        {/* 이용권 구매 */}
        <Route path="/product/purchase">
          <Purchase />
        </Route>
        {/* 고객센터 */}
        <Route path="/customer">
          <CustomerCenter />
        </Route>
        {/* FAQ */}
        <Route path="/faq">
          <Faq />
        </Route>

        {/* 공지사항 */}
        {/* <Route path="/notice/detail/:id" component={NoticeDetail} />
        <Route path="/notice">
          <Notice />
        </Route> */}
        {/* <Route path="/notice/detail/:id" component={NoticeDetail} /> */}
        <Route path="/notice/:detail">
          <NoticeContainer />
        </Route>
        <Route path="/notice">
          <NoticeContainer />
        </Route>

        {/* 나의 쿠폰 */}
        {/* <Route path="/coupon/my">
        </Route> */}

        {/* 계정 관리 */}
        {/* <Route path="/info/my">
        </Route> */}

        <Route exact path="/">
          <Home />
        </Route>
        {/* 에러 */}
        <Route path="/500">
          <Error500 />
        </Route>
        <Route path="*">
          <Error />
        </Route>
      </Switch>
    </main>
  );
}
